// Localization config (Argentina)

import { Localization } from '../../../shared/Localization';

import es from '../../generic/l10n/messages_es';
import en from '../../generic/l10n/messages_en';

const localization = new Localization('default_ar', es, [es, en]);

export default localization;
